import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import hi from '../locales/hi.json';

const LANGUAGE_KEY = '@app_language';

// Get initial language from localStorage or default to 'en'
const getInitialLanguage = (): string => {
  try {
    const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'hi')) {
      return savedLanguage;
    }
  } catch (e) {
    console.warn('Could not read from localStorage:', e);
  }
  return 'en';
};

// Initialize i18n with the initial language
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    lng: getInitialLanguage(), // Use saved language or default to 'en'
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense to avoid issues
    },
  });

// Save language preference when changed
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(LANGUAGE_KEY, lng);
  } catch (e) {
    console.warn('Could not save language to localStorage:', e);
  }
});

// Function to load language from user preference
export const loadUserLanguagePreference = (languagePreference?: string) => {
  if (languagePreference && (languagePreference === 'en' || languagePreference === 'hi')) {
    // Only change if different from current language
    if (i18n.language !== languagePreference) {
      i18n.changeLanguage(languagePreference).catch((err) => {
        console.error('Failed to change language:', err);
      });
    }
    try {
      localStorage.setItem(LANGUAGE_KEY, languagePreference);
    } catch (e) {
      console.warn('Could not save language to localStorage:', e);
    }
  }
};

export default i18n;

